import { useState } from "react";

const useChartConfig = (props, chartEvents) => {
  const getPng = (png) => {
    setChartConfig((prevConfig) => ({ ...prevConfig, downloadPng: png }));
  };

  const [chartConfig, setChartConfig] = useState({
    downloadPng: void 0,
    options: {
      tooltip: {
        enabled: false
      },
      legend: {
        show: false
      },
      stroke: {
        width: props.stroke,
        colors: ["#353942"]
      },
      grid: {
        show: true,
        borderColor: "#353942",
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            color: "white",
            fontSize: "15px"
          }
        }
      },
      xaxis: {
        type: "category",
        categories: props.categories
          ? props.categories
          : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        position: "top",
        labels: {
          show: true,
          offsetY: -20,
          style: {
            fontSize: "15px",
            fontWeight: 700,
            colors: "white"
          }
        }
      },
      chart: {
        toolbar: {
          show: false,
          getPng: props.exportPng && getPng,
          export: {
            png: {
              filename: "HeatMap"
            }
          }
        },
        background: "#262931",
        events: chartEvents
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: undefined,
        textAnchor: "middle",
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: "16px",
          fontFamily: "Roboto, Arial, sans-serif",
          colors: ["#dedede"]
        },
        dropShadow: {
          enabled: false,
          top: 1,
          left: 1,
          blur: 1,
          opacity: 0.45
        }
      },
      fill: {
        opacity: 1,
        type: "solid"
      },
      plotOptions: {
        heatmap: {
          radius: props.heatMapRadius,
          enableShades: true,
          shadeIntensity: 1,
          displayAsBubbles: props.displayAsBubbles,
          filledBubbles: props.filledBubbles,
          colorScale: {
            ranges: [
              {
                from: 0,
                to: 100,
                color: {
                  r: 0,
                  g: 174,
                  b: 239
                },
                name: "51-100%"
              }
            ]
          }
        }
      }
    },
    series: props.series
  });

  return { chartConfig };
};

export default useChartConfig;
